import { connect, MapStateToProps } from "react-redux";

import { getConfigAttributes, getRecordById } from "@multiweb/reactCore/datasource";
import { IAppState } from "@multiweb/types/react";
import { DataRowTemplateComponentProps } from "../../../../components";
import { FrameSharedProps } from "../../../../types";
import { RoleUsersRowTemplateComponent } from "./RoleUsersTemplateComponent";

export type RoleUsersTemplateProps = FrameSharedProps;

type StateProps = Pick<DataRowTemplateComponentProps, "contentDataSourceAttributeNames" | "dataSourceAttributes">;

const mapStateToProps: MapStateToProps<StateProps, RoleUsersTemplateProps, IAppState> = (state, { dataSourceKey, recordId }) => ({
    dataSourceAttributes: getConfigAttributes(state, dataSourceKey),
    record: getRecordById(state, { dataSourceKey, recordId }),
});

export const RoleUsersTemplate = connect(mapStateToProps)(RoleUsersRowTemplateComponent);
